module.exports = __webpack_public_path__ + "media/images/workflow-settings-hover-b401bf0a1565f7b5daf0e1402dd21539.svg";